import APIClient from './index';
import _ from 'lodash';

export const getCatalogToolScope = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`CatalogTool/scope`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const previewCatalogTool = body => {
  return new Promise((resolve, reject) => {
    APIClient.post(`CatalogTool/preview`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const processCatalogTool = body => {
  return new Promise((resolve, reject) => {
    APIClient.post(`CatalogTool/process`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
